import axios, { InternalAxiosRequestConfig } from "axios";

const baseURL = "https://cvd-go.azurewebsites.net/api";

const api = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  const token = localStorage.getItem("accessToken");
  if (token && config.headers) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const getUserPermissions = async (): Promise<any> => {
  try {
    const response = await api.get("/user/permissions");
    return response.data;
  } catch (error) {
    console.error("Error fetching user permissions:", error);
    return { level: "User" };
  }
};

export default api;

export const updateEntryDirection = async (
  entryId: string,
  direction: "in" | "out"
): Promise<void> => {
  try {
    await api.patch(`/trucks/direction/${entryId}`, {
      direction: direction,
    });
  } catch (error) {
    console.error("Error updating truck direction:", error);
    throw error;
  }
};

export const updateLicensePlate = async (
  truckId: string,
  newLicensePlate: string
): Promise<void> => {
  try {
    await api.patch(`/trucks/registration/${truckId}`, {
      registration: newLicensePlate,
    });
  } catch (error) {
    console.error("Error updating truck license plate:", error);
    throw error;
  }
};

export const updateEntryLicensePlate = async (
  entryId: string,
  newLicensePlate: string
): Promise<void> => {
  try {
    await api.patch(`/trucks/registration/${entryId}`, {
      registration: newLicensePlate,
    });
  } catch (error) {
    console.error("Error updating truck license plate:", error);
    throw error;
  }
};

export const deleteEntry = async (entryId: string): Promise<void> => {
  try {
    await api.delete(`/trucks/delete/${entryId}`);
  } catch (error) {
    console.error("Error deleting entry:", error);
    throw error;
  }
};

export const deleteTruck = async (truckId: string): Promise<void> => {
  try {
    await api.delete(`/trucks/delete/${truckId}`);
  } catch (error) {
    console.error("Error deleting truck:", error);
    throw error;
  }
};
